import { createContext, useContext, useState, useCallback, ReactNode } from 'react'
import Loader from 'src/components/shared/ui/Loader/Loader'

type SpinnerReturnedObject = {
  showSpinner: () => void
  closeSpinner: () => void
}

const SpinnerContext = createContext({} as SpinnerReturnedObject)

export function SpinnerContextProvider({ children }: { children: ReactNode }): JSX.Element {
  const [spinnerStatus, setSpinnerStatus] = useState(false)

  const showSpinner = useCallback(() => {
    setSpinnerStatus(true)
  }, [])

  const closeSpinner = useCallback(() => {
    setSpinnerStatus(false)
  }, [])

  return (
    <SpinnerContext.Provider value={{ showSpinner, closeSpinner }}>
      {children}
      {spinnerStatus === true && <Loader fullscreen transparent size="large" />}
    </SpinnerContext.Provider>
  )
}

export function useSpinnerContext(): SpinnerReturnedObject {
  return useContext(SpinnerContext)
}
